<template>
  <div>
    <SatinalmaTopContent
      :gelentur="tur"
      @baslangic="getName"
      @bitis="bitis"
      @aranan="aranan"
      @secilenDurum="secilenDurum"
    />
    <TablesComponent
      ref="tables"
      :gelentur="tur"
      :column="columnDefs"
      :row="rowData"
      :kayitsayisi="KAYITSAYISI"
      @arananfiltre="arananfiltre"
      @sonkayit="sonkayit"
      @ilkkayit="ilkkayit"
    />
  </div>
</template>
<script>
import Store from "../../store/store";
import state from "../../store/state";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import moment from "moment";
import DetayButon from "../components/crm-components/satinalma-components/DetayButon.vue";
import SatinalmaTopContent from "../components/crm-components/satinalma-components/SatinalmaTopContent.vue";
import TablesComponent from "../components/crm-components/satinalma-components/TablesComponent.vue";
export default {
  data() {
    return {
      tur: "Fatura",
      KAYITSAYISI: 0,
      bitisVal: "",
      baslangicVal: "",
      sonkayitVal: "",
      ilkkayitVal: "",
      rowData: [],
      arananVal: "",
      columnDefs: null,
      tumkayit: 0,
      secilenDurumVal: "",
      arananfiltreVal: "",
    };
  },
  components: {
    AgGridVue,
    SatinalmaTopContent,
    DetayButon,
    TablesComponent,
  },
  created() {
    this.satinAlma();
  },
  methods: {
    secilenDurum(value) {
      this.secilenDurumVal = value;
      // this.satinAlma();
    },
    aranan(value) {
      this.arananVal = value;
      this.satinAlma();
    },
    arananfiltre(value) {
      this.arananfiltreVal = value;
      this.satinAlma();
    },
    bitis(value) {
      this.bitisVal = value;
      // this.satinAlma();
    },

    getName(value) {
      this.baslangicVal = value;
      //  this.satinAlma();
    },
    ilkkayit(value) {
      this.ilkkayitVal = value;
      //  this.satinAlma();
    },
    sonkayit(value) {
      this.sonkayitVal = value;
      this.satinAlma();
    },

    parseDate(params) {
      return moment(String(params.value)).format("DD.MM.YYYY");
    },

    satinAlma() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;

      if (vm.arananVal != "") {
        const args = {
          token: Store.state.tokenId,
          TRANSTYPE: "201",
          STATUS: vm.secilenDurumVal,
          ARANAN: vm.arananVal,
          //ay-gün-yıl
          ILKTARIH: vm.baslangicVal,
          SONTARIH: vm.bitisVal,
          ILKKAYIT: "0",
          SONKAYIT: "1000000", //?tumkayıt değeri nereden çekilir
        };
        soap.createClient(url, function (err, client) {
          client.INT_LS_FatSipTeklifBaslik(args, function (err, result) {
            if (result.INT_LS_FatSipTeklifBaslikResult == "-1") {
              Store.dispatch("logout");
            }
            try {
              vm.veriler = JSON.parse(result.INT_LS_FatSipTeklifBaslikResult);
              vm.rowData = vm.veriler;
              vm.$store.commit("account/SAT_ROWDATA", vm.veriler);
              vm.KAYITSAYISI = vm.veriler[0].KAYITSAYISI;
              vm.tumkayit = vm.veriler[0].KAYITSAYISI;
              vm.$store.commit(
                "account/KAYITSAYISI_TUT",
                vm.veriler[0].KAYITSAYISI
              );
            } catch (error) {
              console.log(error);
            }
          });
        });

        vm.arananVal = "";
      } else if (vm.arananfiltreVal != "") {
        const args = {
          token: Store.state.tokenId,
          TRANSTYPE: "201",
          STATUS: vm.secilenDurumVal,
          ARANAN: vm.arananfiltreVal,
          //ay-gün-yıl
          ILKTARIH: vm.baslangicVal,
          SONTARIH: vm.bitisVal,
          ILKKAYIT: "0",
          SONKAYIT: "1000000", //?tumkayıt değeri nereden çekilir
        };
        soap.createClient(url, function (err, client) {
          client.INT_LS_FatSipTeklifBaslik(args, function (err, result) {
            if (result.INT_LS_FatSipTeklifBaslikResult == "-1") {
              Store.dispatch("logout");
            }
            try {
              vm.veriler = JSON.parse(result.INT_LS_FatSipTeklifBaslikResult);
              vm.rowData = vm.veriler;
              vm.$store.commit("account/SAT_ROWDATA", vm.veriler);
              vm.KAYITSAYISI = vm.veriler[0].KAYITSAYISI;
              vm.tumkayit = vm.veriler[0].KAYITSAYISI;
              vm.$store.commit(
                "account/KAYITSAYISI_TUT",
                vm.veriler[0].KAYITSAYISI
              );
            } catch (error) {
              console.log(error);
            }
          });
        });

        vm.arananfiltre = "";
      } else if (vm.bitisVal != "" && vm.sonkayitVal != "") {
        const args = {
          token: Store.state.tokenId,
          TRANSTYPE: "201",
          STATUS: vm.secilenDurumVal,
          ARANAN: "",
          //ay-gün-yıl
          ILKTARIH: vm.baslangicVal,
          SONTARIH: vm.bitisVal,
          ILKKAYIT: vm.ilkkayitVal,
          SONKAYIT: vm.sonkayitVal,
        };
        soap.createClient(url, function (err, client) {
          client.INT_LS_FatSipTeklifBaslik(args, function (err, result) {
            if (result.INT_LS_FatSipTeklifBaslikResult == "-1") {
              Store.dispatch("logout");
            }
            try {
              vm.veriler = JSON.parse(result.INT_LS_FatSipTeklifBaslikResult);
              vm.rowData = vm.veriler;
              vm.$store.commit("account/SAT_ROWDATA", vm.veriler);
              vm.KAYITSAYISI = vm.veriler[0].KAYITSAYISI;
              vm.tumkayit = vm.veriler[0].KAYITSAYISI;
              vm.$store.commit(
                "account/KAYITSAYISI_TUT",
                vm.veriler[0].KAYITSAYISI
              );
            } catch (error) {
              console.log(error);
            }
          });
        });
        vm.baslangicVal = "";
        vm.bitisVal = "";
        vm.sonkayitVal = "";
        vm.ilkkayitVal = "";
      }
    },
    currencyFormatter(currency, sign) {
      if (currency == "") {
        return "";
      } else {
        var sansDec = currency.toFixed(2);
        var formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return sign + `${formatted}`;
      }
    },
  },

  beforeMount() {
    this.columnDefs = [
      {
        width: 100,
        field: "",
        cellRendererFramework: "DetayButon",
      },
      {
        headerName: "Cari Adı",
        field: "ACTNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Tarih",
        sortable: true,
        filter: "agDateColumnFilter",
        field: "TRANSDATE",
        valueFormatter: this.parseDate,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Fatura No",
        field: "RECEIPTNO",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Vade",
        field: "DUEDATE",
        sortable: true,
        filter: "agDateColumnFilter",
        valueFormatter: this.parseDate,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Vade Gün",
        field: "DUEDAY",
        sortable: true,
        filter: "agNumberColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Açıklama",
        field: "DESCRIPTION",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Ürün Toplamı",
        field: "PRODUCTSUM",
        sortable: true,
        filter: "agNumberColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        type: "rightAligned",
        valueFormatter: (params) =>
          this.currencyFormatter(params.data.PRODUCTSUM, "₺"),
      },
      {
        headerName: "İskonto",
        field: "DISCOUNTSUM",
        sortable: true,
        filter: "agNumberColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "KDV",
        field: "VATSUM",
        sortable: true,
        filter: "agNumberColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        type: "rightAligned",
        valueFormatter: (params) =>
          this.currencyFormatter(params.data.VATSUM, "₺"),
      },
      {
        headerName: "Toplam",
        field: "TOTAL",
        sortable: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        filter: "agNumberColumnFilter",
        type: "rightAligned",
        valueFormatter: (params) =>
          this.currencyFormatter(params.data.TOTAL, "₺"),
      },
    ];
  },
};
</script>